import { Component, OnInit } from '@angular/core';
import {AdminService} from '../_services/admin.service';
import {LoginService} from '../login/login.service';
import { Observable, Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})
export class AdminComponent implements OnInit {

  users: any[] = [];  
  listAllMid : any[] = [];
  listUserMid: any[] = [];
  displaypicklist:boolean = false;  
  userid:any = null;
  timersub: Subscription;

  constructor(private asr:AdminService,private ls:LoginService) 
  {
      
      
  }

  public addMidToUser(evt)
  {
      
      for (let mid of evt.items)
      {    
         
          this.asr.addusermid(this.userid, mid.ob_mid).subscribe(d=>{console.log(d)},e=>{console.log(e)});
      }    
  }
  
  public deleteMidFromUser(evt)
  {
      for (let mid of evt.items)
      {    
        
          //console.log(mid);
          this.asr. deleteusermid(mid.id).subscribe(d=>{console.log(d);},e=>{console.log(e)},()=>{});
          
      }    
     
  }
  
  public addMid(user)
  {
      
      this.userid = user.id;
      this.displaypicklist = true;
      this.listUserMid = [];
      this.listAllMid = [];
      this.asr.getAvailableMid().pipe(mergeMap((f: any) => f)).subscribe((d: any) => {
          this.listAllMid.push({ob_mid:d.ob_mid,label:d.obcina})
      },e=>{},()=>{
          
          
          this.asr.getUsersMid(user.id).pipe(mergeMap((f: any) => f)).subscribe((d: any) => {
              
             
              var idx =  this.listAllMid.map(x => x.ob_mid).indexOf(d.ob_mid);
              this.listAllMid.splice(idx,1);
              this.listUserMid.push({ob_mid:d.ob_mid,label:d.obcina,id:d.id});
                
            })
          
      });
      
     
  }
  
  
  public loadUsers():void
  {
      this.users = [];
      this.asr.syncKcDbUsers(this.users);
  }
  
  ngOnInit() 
  {
      
      this.loadUsers();
    
      
  }

}
